export const pathnameWithLanguage = (
  languageCode: LanguageCode,
  pathname: string
): string => `/${languageCode}${pathname}`;
